<template>
  <div class="container">
    <breadcrumb crumb="edm-users" />
    <section class="users_section_filter">
      <el-row>
        <el-col :span="12">
          <search-input
            placeholder="Поиск по названию, ИНН или телефону"
            @clear="clearFilter"
            @search="handeSearch"
            @input="onInput"
          />
        </el-col>
        <el-col :span="12" class="top-section-right">
          <div class="center">
            <p @click="openModal()">Добавить пользователя эцп</p>
          </div>
        </el-col>
      </el-row>
    </section>
    <el-table
      v-if="loading || !usersList.length"
      v-loading="loading"
      :data="usersList"
      style="width: 100%; height: 40vh; margin-top: 40px"
    />
    <section v-if="usersList.length && !loading" class="middle-section_users">
      <el-row :gutter="24" class="title-row" type="flex">
        <el-col :span="3" :push="1">Дата</el-col>
        <el-col :span="5">Логин/телефон</el-col>
        <el-col :span="6">Название организации</el-col>
        <el-col :span="3">Стутус</el-col>
        <el-col :span="4">Дата окончания</el-col>
      </el-row>
      <el-row
        v-for="u in usersList"
        :key="u.id"
        :gutter="24"
        type="flex"
        align="middle"
        class="check-list"
      >
        <el-col class="auto-list_col" :span="3" :push="1">
          <div class="check-list-person grey">
            <div>
              <p v-if="u.created_at" class="date">
                {{ dateToFormat(u.created_at) | wordDate }}
              </p>
              <p v-else class="date">не указано</p>
              <p class="date" style="padding-top: 5px">
                {{ dateToFormat(u.created_at) | sliceDate }}
              </p>
            </div>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="5">
          <div class="check-list-person">
            <p>
              <input
                v-mask="'+7 (###) ###-##-##'"
                class="doc-phone"
                :value="u.phone"
                masked="true"
                readonly
              />
            </p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="6">
          <div class="check-list-person grey">
            <p>{{ u.org_name }}</p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="3">
          <div class="check-list-person green_color">
            <p>Выпущена</p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <div class="check-list-person">
            <p>
              {{ dateToFormat(u.activation_code_expires_at) | wordDate('до ') }}
            </p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="3">
          <div class="check-list-action">
            <p>
              <el-button
                type="success"
                icon="el-icon-edit"
                class="no-events"
                circle
                @click="openModal(u)"
              />
            </p>
            <p>
              <el-button
                data-goal="1"
                type="danger"
                icon="el-icon-delete"
                class="no-events"
                circle
                @click="beforeDelete(u.id)"
              />
            </p>
          </div>
        </el-col>
      </el-row>
    </section>
    <edm-user-modal :visible="edmUserModal" :user="user" @close="onClose" />
  </div>
</template>

<script>
import { DELETE_EDM_USER, SET_LOADING } from '@/store/actions/edmUsers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import EdmUserModal from './components/EdmUserModal'
import SearchInput from '@/components/Shared/SearchInput'

const EdmUsers = RepositoryFactory.get('edmUsers')

export default {
  name: 'EdmUsers',
  components: {
    Breadcrumb,
    SearchInput,
    EdmUserModal,
  },
  data() {
    return {
      edmUserModal: false,
      search_input: '',
      user: null,
    }
  },
  mounted() {
    this.loadPage()
  },
  computed: {
    ...mapGetters({
      loading: 'edmUsers/getLoading',
      usersList: 'edmUsers/getUsers',
    }),
  },
  methods: {
    async loadPage() {
      await this.getList()
    },
    getList(search) {
      const settings = search ? { search } : {}

      this.$store.dispatch('edmUsers/fetchUsers', settings)
    },
    onInput(cur) {
      this.search_input = cur
    },
    clearFilter() {
      this.search_input = ''
      this.getList()
    },
    handeSearch() {
      if (!this.search_input) {
        return
      }
      const filterValue = String(this.search_input).trim()

      if (filterValue.length > 2) {
        this.getList(filterValue)
      }
    },
    openModal(user = null) {
      this.edmUserModal = true
      this.user = user ? { ...user } : null
    },
    onClose() {
      this.edmUserModal = false
      this.user = null
    },
    beforeDelete(id) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => this.deleteItem(id))
    },
    deleteItem(id) {
      this.setLoading(true)
      EdmUsers.deleteItem(id)
        .then(res => {
          if (res.status === 204) {
            this.$message.success('Запись удалена успешно')
            this.$store.commit(`edmUsers/${DELETE_EDM_USER}`, { id })
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => this.setLoading(false))
    },
    setLoading(flag) {
      this.$store.commit(`edmUsers/${SET_LOADING}`, flag)
    },
  },
}
</script>

<style lang="sass">
.el-message-box.before-del
  width: 90%
.no-events
  i
    pointer-events: none
.users_section_filter
  padding: 0 15px
  .top-section-right
    p
      font-size: 18px
      line-height: 21px
      color: #3498DB
      &:hover
        text-decoration: underline
        cursor: pointer
    .center
      display: flex
      align-items: center
      justify-content: flex-end
      span
        margin-left: 14px
.middle-section_users
  .title-row
    text-align: center
    margin-top: 40px
  .check-list
    margin: 20px 0
    background: #fff
    height: 100px
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
    .el-row
      height: 100%
    .check-list-person
      &.green_color p
        color: #2ECC71
        font-weight: bold
      &.grey p
        color: #98A9BC
      p
        font-size: 18px
        line-height: 22px
        margin: 0
        color: #252631
      .doc-phone
        font-size: 18px
        border: none
        text-align: center
        width: 100%
        outline: none
    .auto-list_col
      text-align: center
      height: auto
    .check-list-action
      display: flex
      margin-right: 10px
      justify-content: flex-end
      img
        margin: 10px
      p
        margin: 0 5px
</style>
